<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Betalinger</mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="45" class="settings-list">
        <dt>Betalingsfil</dt>
        <dd>
          @switch (value['file-format']) {
            @case ('PaymentsXlsx') {
              <span>Generisk (Excel)</span>
            }
            @case ('NordeaCsv') {
              <span>Nordea (CSV)</span>
            }
            @case ('BusinessOnlineCsv') {
              <span>Danske Bank (CSV)</span>
            }
            @case ('NykreditCsv') {
              <span>ERH – Bankens Erhvervsformat (BEC)</span>
            }
            @case ('SydbankCsv') {
              <span>BankData (SydBank, m.fl.)</span>
            }
            @case ('OpusPaymentsTxt') {
              <span>Opus (KMD)</span>
            }
            @default {
              <span>Generisk (Excel)</span>
            }
          }
        </dd>
        @if (value['file-format'] === 'PaymentsXlsx') {
          <dt>Søjler i betalingsfil</dt>
          <dd>
            @if (!value['file-columns']?.length) {
              <span>Standardsøjler</span>
            }
            @for (column of value['file-columns']; track $index) {
              <div>{{ column.key }} ({{ fileColumnStyle(column.style) }}, bredde {{ column.width }}{{ column.format ? ', ' + column.format : '' }})</div>
            }
          </dd>
        }
        @if (showUsePNo()) {
          <dt>Tillad P-nummer i virksomheds NemKonto</dt>
          <dd>{{value.use_p_no ? 'Ja' : 'Nej'}}</dd>
        }
        <dt>Tving udbetalingsdatoer ud i fremtiden</dt>
        <dd>{{value.force_future ? 'Ja' : 'Nej'}}</dd>
        <dt>Betalingsfrekvens</dt>
        <dd>
          @switch (value.frequency_mode) {
            @case ('apmf') {
              <span>APMF (torsdag i ulige uger)</span>
            }
            @default {
              <span>Standard (faste ugedage)</span>
            }
          }
        </dd>
        @if (value.frequency_mode === 'default') {
          <dt>Ugedage</dt>
          <dd>
            @if (!value.frequency?.length) {
              <span>Alle hverdage</span>
            }
            @if (value.frequency?.length) {
              <span>{{ weekDays(value.frequency).join(', ')}}</span>
            }
          </dd>
        }
        <dt>Betalinger sendes før betalingsdato</dt>
        <dd>{{ value.export_cutoff }} dage</dd>
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <dl fxFlex="45" class="settings-list">
        <dt>Besked til ansøger ved udbetaling</dt>
        <dd>{{ value.notify_applicant ? 'Ja' : 'Nej' }}</dd>

        <dt>Økonomifunktions email</dt>
        <dd>
          @if (!value.notify_accounting) {
            <span> -- </span>
          }
          @if (value.notify_accounting) {
            <span>{{ value.notify_accounting }}</span>
          }
        </dd>
        <dt>Dan bilag ved bevilling</dt>
        <dd>{{ value.notify_on_initial_addendum ? 'Ja' : 'Nej' }}</dd>
        <dt>Dan bilag ved tillægsbevilling</dt>
        <dd>
          {{ value.notify_on_additional_addendum ? 'Ja' : 'Nej' }}
          @if (value.notify_on_additional_addendum && value.additional_addendum_show_past) {<span> (m. tidligere)</span>}
          @if (value.notify_on_additional_addendum && value.additional_addendum_show_totals) {<span> (m. total)</span>}
        </dd>
        <dt>Dan bilag ved udbetaling</dt>
        <dd>
          {{ value.notify_on_outgoing ? 'Ja' : 'Nej' }}
          @if (value.notify_on_outgoing && value.outgoing_show_past) {<span> (m. tidligere)</span>}
          @if (value.notify_on_outgoing && value.outgoing_show_totals) {<span> (m. total)</span>}
        </dd>
        <dt>Dan bilag ved indbetaling</dt>
        <dd>
          {{ value.notify_on_incoming ? 'Ja' : 'Nej' }}
          @if (value.notify_on_incoming && value.incoming_show_past) {<span> (m. tidligere)</span>}
          @if (value.notify_on_incoming && value.incoming_show_totals) {<span> (m. total)</span>}
        </dd>
        <dt>Dan bilag ved nedskrivning</dt>
        <dd>
        <dd>
          {{ value.notify_on_dropped ? 'Ja' : 'Nej' }}
          @if (value.notify_on_dropped && value.dropped_show_past) {<span> (m. tidligere)</span>}
          @if (value.notify_on_dropped && value.dropped_show_totals) {<span> (m. total)</span>}
        </dd>
        <dt>Dan bilag ved overførsel</dt>
        <dd>
          {{ value.notify_on_transfer ? 'Ja' : 'Nej' }}
          @if (value.notify_on_transfer && value.transfer_show_past) {<span> (med tidligere)</span>}
          @if (value.notify_on_transfer && value.transfer_show_totals) {<span> (med total)</span>}
        </dd>
        <dt>Dan bilag ved kursdifference</dt>
        <dd>{{ value.notify_on_exchange_rate_diff ? 'Ja' : 'Nej' }}</dd>
      </dl>
    </div>
    <mat-divider class="my-3"></mat-divider>
    <div fxLayout="column" class="mb-3">
      <h4 class="mat-h4 mb-2">Valutabaseret betalingsruting</h4>
      @if (!currencyRoutesList.length) {
        <span class="text-muted">Ingen</span>
      }
      @if (currencyRoutesList.length) {
        <table class="table table-sm" role="table">
          <thead>
            <tr role="row">
              <th role="columnheader">Valuta</th>
              <th role="columnheader">Kontonummer</th>
              <th role="columnheader">SWIFT / BIC</th>
              <th role="columnheader">Regnskab</th>
            </tr>
          </thead>
          <tbody>
            @for (route of currencyRoutesList; track route.currency) {
              <tr role="row">
                <td role="cell"><strong>{{ route.currency }}</strong></td>
                <td role="cell">{{ route.account_no }}</td>
                <td role="cell">{{ route.swift || '--' }}</td>
                <td role="cell">{{ route.accounting || '--' }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
        <div fxFlex="45" fxLayout="column">
          <div fxLayout="column">
            <label>Betalingsfil</label>
            <p>Vælg det format, som svarer til fondens netbank. Kun relevant for manuel overførsel. Se evt.
              <a href="https://www.bankconnect.dk/da/faq/pengeinstitutter" target="_blank">liste over banker for bank centraler</a>.
            </p>
            <mat-form-field>
              <mat-select formControlName="file-format">
                <mat-option value="PaymentsXlsx">Generisk (Excel)</mat-option>
                <mat-option value="NordeaCsv">Nordea</mat-option>
                <mat-option value="BusinessOnlineCsv">Danske Bank</mat-option>
                <mat-option value="NykreditCsv">ERH – Bankens Erhvervsformat (BEC)</mat-option>
                <mat-option value="SydbankCsv">BankData (SydBank, m.fl.)</mat-option>
                <mat-option value="OpusPaymentsTxt">Opus (KMD)</mat-option>
              </mat-select>
              @if (form.controls['file-format'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="mb-2">
            @if (showUsePNo()) {
              <mat-checkbox ngDefaultControl formControlName="use_p_no">Tillad P-nummer i virksomheds NemKonto.</mat-checkbox>
            }
            <mat-checkbox ngDefaultControl formControlName="force_future">Tving udbetalingsdatoer til at være i fremtiden.</mat-checkbox>
          </div>
          <div fxLayout="column">
            <label>Betalingsfrekvens</label>
            <mat-form-field>
              <mat-select formControlName="frequency_mode">
                <mat-option value="default">Standard (faste ugedage)</mat-option>
                <mat-option value="apmf">APMF (torsdag i ulige uger)</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          @if (frequencyMode.value === 'default') {
            <div fxLayout="column">
              <label>Betalingsfrekvens</label>
              <mat-form-field>
                <mat-select formControlName="frequency" multiple>
                  <mat-option [value]="1">Mandag</mat-option>
                  <mat-option [value]="2">Tirsdag</mat-option>
                  <mat-option [value]="3">Onsdag</mat-option>
                  <mat-option [value]="4">Torsdag</mat-option>
                  <mat-option [value]="5">Fredag</mat-option>
                </mat-select>
                <mat-hint>Angiv hvor ofte automatisk betalingsfiler skal overføres. Intet valg svarer til dagligt.</mat-hint>
              </mat-form-field>
            </div>
          }
          <div fxLayout="column" class="mt-3">
            <label>Betalinger sendes før betalingsdato (standard 3 dage pga NemKonto)</label>
            <mat-form-field>
              <input type="number" matInput formControlName="export_cutoff">
              <mat-hint>Hvor mange bankdage før ønsket betalingsdato sendes betalinger til banken.</mat-hint>
              @if (form.controls['export_cutoff'].hasError('required')) {
                <mat-error>Skal angives.</mat-error>
              }
              @if (form.controls['export_cutoff'].hasError('min')) {
                <mat-error>Mindst 1 dag før.</mat-error>
              }
              @if (form.controls['export_cutoff'].hasError('max')) {
                <mat-error>Højst 100 dage før.</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div fxFlex="45" fxLayout="column">
          <div>
            <mat-checkbox ngDefaultControl formControlName="notify_applicant">Send besked til <em>ansøger</em> ved ekspedition af udbetaling</mat-checkbox>
          </div>
          <div fxLayout="column" class="mt-3">
            <label>Økonomifunktions email</label>
            <mat-form-field>
              <input type="email" matInput formControlName="notify_accounting">
              <mat-hint>Hvis angivet sendes betalingsbilag til email ved ekspedition.</mat-hint>
              @if (form.controls['notify_accounting'].hasError('email')) {
                <mat-error>Ugyldig email.</mat-error>
              }
              @if (form.controls['notify_accounting'].hasError('maxlength')) {
                <mat-error>Højst 100 tegn.</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="mt-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
            <mat-checkbox ngDefaultControl formControlName="notify_on_initial_addendum">Dan bilag ved ekspedition af bevilling</mat-checkbox>
            @if (form.get('notify_on_initial_addendum')?.value) {
              <button
                type="button"
                mat-icon-button
                matTooltip="Rediger bilagstekst for bevilling"
                [attr.aria-label]="'Rediger bilagstekst for bevilling'"
                (click)="openPdfTextDialog('initial_addendum')"
              ><mat-icon>edit</mat-icon></button>
            }
          </div>
          <div class="mt-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
            <mat-checkbox ngDefaultControl formControlName="notify_on_additional_addendum">Dan bilag ved ekspedition af tillægsbevilling</mat-checkbox>
            @if (form.get('notify_on_additional_addendum')?.value) {
              <button
                type="button"
                mat-icon-button
                matTooltip="Rediger bilagstekst for bevilling"
                [attr.aria-label]="'Rediger bilagstekst for tillægsbevilling'"
                (click)="openPdfTextDialog('additional_addendum')"
              ><mat-icon>edit</mat-icon></button>
            }
          </div>
          @if (form.get('notify_on_additional_addendum')?.value) {
            <div class="mt-1 pl-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
              <mat-checkbox ngDefaultControl formControlName="additional_addendum_show_totals">Vis totaler</mat-checkbox>
            </div>
            <div class="mt-1 pl-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
              <mat-checkbox ngDefaultControl formControlName="additional_addendum_show_past">Vis tidligere posteringer</mat-checkbox>
            </div>
          }
          <div class="mt-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
            <mat-checkbox ngDefaultControl formControlName="notify_on_outgoing">Dan bilag ved ekspedition af udbetaling</mat-checkbox>
            @if (form.get('notify_on_outgoing')?.value) {
              <button
                type="button"
                mat-icon-button
                matTooltip="Rediger bilagstekst for udbetaling"
                [attr.aria-label]="'Rediger bilagstekst for udbetaling'"
                (click)="openPdfTextDialog('outgoing')"
              ><mat-icon>edit</mat-icon></button>
            }
          </div>
          @if (form.get('notify_on_outgoing')?.value) {
            <div class="mt-1 pl-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
              <mat-checkbox ngDefaultControl formControlName="outgoing_show_totals">Vis totaler</mat-checkbox>
            </div>
            <div class="mt-1 pl-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
              <mat-checkbox ngDefaultControl formControlName="outgoing_show_past">Vis tidligere posteringer</mat-checkbox>
            </div>
          }
          <div class="mt-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
            <mat-checkbox ngDefaultControl formControlName="notify_on_incoming">Dan bilag ved ekspedition af indbetaling</mat-checkbox>
            @if (form.get('notify_on_incoming')?.value) {
              <button
                type="button"
                mat-icon-button
                matTooltip="Rediger bilagstekst for indbetaling"
                [attr.aria-label]="'Rediger bilagstekst for indbetaling'"
                (click)="openPdfTextDialog('incoming')"
              ><mat-icon>edit</mat-icon></button>
            }
          </div>
          @if (form.get('notify_on_incoming')?.value) {
            <div class="mt-1 pl-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
              <mat-checkbox ngDefaultControl formControlName="incoming_show_totals">Vis totaler</mat-checkbox>
            </div>
            <div class="mt-1 pl-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
              <mat-checkbox ngDefaultControl formControlName="incoming_show_past">Vis tidligere posteringer</mat-checkbox>
            </div>
          }
          <div class="mt-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
            <mat-checkbox ngDefaultControl formControlName="notify_on_dropped">Dan bilag ved ekspedition af nedskrivning</mat-checkbox>
            @if (form.get('notify_on_dropped')?.value) {
              <button
                type="button"
                mat-icon-button
                matTooltip="Rediger bilagstekst for nedskrivning"
                [attr.aria-label]="'Rediger bilagstekst for nedskrivning'"
                (click)="openPdfTextDialog('dropped')"
              ><mat-icon>edit</mat-icon></button>
            }
          </div>
          @if (form.get('notify_on_dropped')?.value) {
            <div class="mt-1 pl-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
              <mat-checkbox ngDefaultControl formControlName="dropped_show_totals">Vis totaler</mat-checkbox>
            </div>
            <div class="mt-1 pl-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
              <mat-checkbox ngDefaultControl formControlName="dropped_show_past">Vis tidligere posteringer</mat-checkbox>
            </div>
          }
          <div class="mt-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
            <mat-checkbox ngDefaultControl formControlName="notify_on_transfer">Dan bilag ved ekspedition af overførsel</mat-checkbox>
            @if (form.get('notify_on_transfer')?.value) {
              <button
                type="button"
                mat-icon-button
                matTooltip="Rediger bilagstekst for overførsel"
                [attr.aria-label]="'Rediger bilagstekst for overførsel'"
                (click)="openPdfTextDialog('transfer')"
              ><mat-icon>edit</mat-icon></button>
            }
          </div>
          @if (form.get('notify_on_transfer')?.value) {
            <div class="mt-1 pl-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
              <mat-checkbox ngDefaultControl formControlName="transfer_show_totals">Vis totaler</mat-checkbox>
            </div>
            <div class="mt-1 pl-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
              <mat-checkbox ngDefaultControl formControlName="transfer_show_past">Vis tidligere posteringer</mat-checkbox>
            </div>
          }
          <div class="mt-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
            <mat-checkbox ngDefaultControl formControlName="notify_on_exchange_rate_diff">Dan bilag ved dannelse af kursdifference</mat-checkbox>
            @if (form.get('notify_on_exchange_rate_diff')?.value) {
              <button
                type="button"
                mat-icon-button
                matTooltip="Rediger bilagstekst for kursdifference"
                [attr.aria-label]="'Rediger bilagstekst for kursdifference'"
                (click)="openPdfTextDialog('exchange_rate_diff')"
              ><mat-icon>edit</mat-icon></button>
            }
          </div>
        </div>
      </div>
      @if (showFileColumns()) {
        <div fxLayout="column" formArrayName="file-columns" class="mb-3">
          <label>Søjler i betalingsfil</label>
          <p>Angiv søjlerne i den generiske Excel-fil. Uden søjler benyttes standardsøjlerne.</p>
          @for (_ of fileColumns.controls; track _; let i = $index) {
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1em" [formGroupName]="i">
              <mat-form-field fxFlex="30">
                <mat-label>Felt</mat-label>/
                <input type="text" matInput formControlName="key">
                @if (fileColumnControl(i, 'key').hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
                @if (fileColumnControl(i, 'key').hasError('maxlength')) {
                  <mat-error>Højst 100 tegn.</mat-error>
                }
              </mat-form-field>
              <mat-form-field fxFlex="15">
                <mat-label>Bredde</mat-label>
                <input type="number" min="1" matInput formControlName="width">
                @if (fileColumnControl(i, 'width').hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
                @if (fileColumnControl(i, 'width').hasError('min')) {
                  <mat-error>Mindst 1.</mat-error>
                }
              </mat-form-field>
              <mat-form-field fxFlex="20">
                <mat-label>Type</mat-label>
                <mat-select formControlName="style">
                  <mat-option value="text">Tekst</mat-option>
                  <mat-option value="date">Dato</mat-option>
                  <mat-option value="amount">Beløb</mat-option>
                </mat-select>
                @if (fileColumnControl(i, 'style').hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
              </mat-form-field>
              <mat-form-field fxFlex="25">
                <mat-label>Format</mat-label>
                <input type="text" matInput formControlName="format" placeholder="dd-mm-yyyy">
                <mat-hint>Valgfrit. Excel-format, f.eks. <code>dd-mm-yyyy</code> eller <code>#,##0.00</code>.</mat-hint>
                @if (fileColumnControl(i, 'format').hasError('maxlength')) {
                  <mat-error>Højst 100 tegn.</mat-error>
                }
              </mat-form-field>
              <button
                type="button"
                mat-icon-button
                matTooltip="Slet søjle"
                [attr.aria-label]="'Slet søjle'"
                (click)="doRemoveFileColumn(i)"
              ><mat-icon>delete</mat-icon></button>
            </div>
          }
          <div class="mt-3">
            <button
              type="button"
              mat-stroked-button
              matTooltip="Tilføj søjle"
              (click)="doAddFileColumn()"
            >Tilføj søjle</button>
          </div>
        </div>
      }
      <mat-divider class="my-3"></mat-divider>
      <div fxLayout="column" formArrayName="currency_based_routing" class="mb-3">
        <label>Valutabaseret betalingsruting</label>
        <p>Konfigurer specifikke udbetalingskonti baseret på valuta.</p>
        @for (_ of currencyRoutes.controls; track $index; let i = $index) {
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1em" [formGroupName]="i" class="mb-2">
            <mat-form-field fxFlex="15">
              <mat-label>Valuta</mat-label>
              <input type="text" matInput formControlName="currency" placeholder="Valuta (f.eks. EUR)">
              @if (currencyRouteControl(i, 'currency').hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (currencyRouteControl(i, 'currency').hasError('pattern')) {
                <mat-error>Skal være 3 bogstaver.</mat-error>
              }
              @if (currencyRouteControl(i, 'currency').hasError('duplicate')) {
                <mat-error>Valutaen er allerede angivet.</mat-error>
              }
            </mat-form-field>
            <mat-form-field fxFlex="30">
              <mat-label>Debitkonto</mat-label>
              <input type="text" matInput formControlName="account_no" placeholder="Kontonummer">
              @if (currencyRouteControl(i, 'account_no').hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (currencyRouteControl(i, 'account_no').hasError('maxlength')) {
                <mat-error>Højst 20 tegn.</mat-error>
              }
            </mat-form-field>
            <mat-form-field fxFlex="25">
              <mat-label>SWIFT / BIC</mat-label>
              <input type="text" matInput formControlName="swift" placeholder="SWIFT / BIC">
              @if (currencyRouteControl(i, 'swift').hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (currencyRouteControl(i, 'swift').hasError('pattern')) {
                <mat-error>Skal være 8 eller 11 store bogstaver og tal.</mat-error>
              }
            </mat-form-field>
            <mat-form-field fxFlex="25">
              <mat-label>Regnskabskonto</mat-label>
              <input type="text" matInput formControlName="accounting" placeholder="Regnskab">
              @if (currencyRouteControl(i, 'accounting').hasError('maxlength')) {
                <mat-error>Højst 100 tegn.</mat-error>
              }
            </mat-form-field>
            <button
              type="button"
              mat-icon-button
              matTooltip="Slet rute"
              [attr.aria-label]="'Slet rute'"
              (click)="doRemoveCurrencyRoute(i)"
            ><mat-icon>delete</mat-icon></button>
          </div>
        }
        <div class="mt-2">
          <button
            type="button"
            mat-stroked-button
            matTooltip="Tilføj rute"
            (click)="doAddCurrencyRoute()"
          >Tilføj rute</button>
        </div>
      </div>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button (click)="doCancel()">Fortryd</button>
        <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
